import {Directive, HostBinding, Input} from "@angular/core";
import {INT_NSM_NS_STATES} from "../../extensions";

@Directive({
  selector: '[intNsDnsStatusColor]'
})
export class IntNsDnsStatusColorDirective {
  @Input() status: keyof typeof INT_NSM_NS_STATES | null = null;

  @HostBinding('attr.data-status') get _status() {
    return this.status ? this.status.toLowerCase() : null;
  }
  @HostBinding('style.color') get _color() {
    switch (this._status) {
      case 'active': {
        return '#00c353';
      }; break;
      case 'invalid': {
        return 'red';
      }; break;
      case 'inactive': {
        return '#A9AEBE'
      }; break;
      case 'pending_create':
      case 'pending_update':
      case 'pending_delete':
      case 'pending_deactivate':
      case 'pending_activate': {
        return '#decb0c';
      };
      default: return '#decb0c';
    }
  }
}
